"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreSanitize = _interopRequireDefault(require("../core-sanitize"));
var _coreMessaging = _interopRequireDefault(require("../core-messaging"));
var _coreLog = _interopRequireDefault(require("../core-log"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */ /**
* SDK Core Callback
*
* - creates base callback payload
*
* @module core-callback
*
* @author Nathan Freeling
* @copyright 2018 Wells Fargo, All rights reserved.
*/
/**
 * CORE callbacks
 *
 * The callback value is the object path of the callback function in SDK external options
 * passed to bootstrap but delimited with a ':' rather than a '.'
 */
var callbacks = {
  generalExit: 'callback:general:exit',
  generalError: 'callback:general:error',
  generalSecureConfigurationError: 'callback:general:secure_configuration_error',
  generalReady: 'callback:general:ready',
  generalStart: 'callback:general:start',
  generalLog: 'callback:general:log',
  generalRatelimit: 'callback:general:ratelimit'
};

/**
 * CORE NETWORK LOG CALLBACKS
 *
 * The following callbacks will be logged to the network logging service
 */
var networkLogCallbacks = [callbacks.generalError, callbacks.generalSecureConfigurationError, callbacks.generalLog];

/**
 * Creates a basic callback payload with timestamp and context KVPs
 *
 * @param {string} [context] Callback context, defaults to 'default'
 * @return {*} A basic callback payload object
 */
function createBaseCallbackPayload(context) {
  var ts = new Date().toISOString();
  return {
    'context': _coreSanitize["default"].sanitizeAll(context),
    'timestamp': ts
  };
}

/**
 * Invoke a callback function in our parent partner DOM through the SDK bootstrap component
 *
 * @param {string} name The callback name
 * @param {*} [customPayload] Payload specific to this action, defaults to {}
 * @param {string} [context] The context of this callback, defaults to 'default'
 */
var invokeParentCallback = function invokeParentCallback(name, customPayload, context) {
  if (!context) {
    context = 'default';
  }
  if (!customPayload) {
    customPayload = {};
  }
  var basePayload = createBaseCallbackPayload(context);
  var payload = _objectSpread(_objectSpread({}, basePayload), customPayload);
  if (networkLogCallbacks.includes(name)) {
    // create network payload, if necessary
    var networkPayload = {
      sdk_client_request_id: payload.sdk_client_request_id || payload.client_request_id,
      sdk_error_code: payload.sdk_error_code || payload.error_code,
      sdk_version: payload.sdk_version || _coreConfig["default"].get(_coreConfig["default"].internal).sdkInternalVersion || _coreConfig["default"].get(_coreConfig["default"].internal).resourceBundleVersion,
      sdk_merchant_number: payload.sdk_merchant_number || _coreConfig["default"].get(_coreConfig["default"].external).merchantNumber,
      sdk_browser_timestamp: payload.sdk_browser_timestamp || payload.timestamp,
      sdk_event_type: payload.sdk_event_type || name,
      sdk_event_page: payload.sdk_event_page || payload.pageName,
      sdk_event_context: payload.sdk_event_context || payload.context,
      sdk_event_description: payload.sdk_event_description || payload.error_message || payload.message
    };
    _coreLog["default"].networkLog(name, networkPayload);
  }
  _coreMessaging["default"].sendMessage({
    action: _coreSanitize["default"].sanitizeAll(name),
    data: payload
  });
};
var _default = exports["default"] = {
  invokeParentCallback: invokeParentCallback,
  callbacks: callbacks,
  networkLogCallbacks: networkLogCallbacks
};
//# sourceMappingURL=index.js.map